import { Crown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/** Only the server-confirmed Premier tier earns public listing recognition. */
export function ProOwnerBadge({
  ownerProTier,
  size = "sm",
}: {
  ownerProTier?: string | null;
  size?: "sm" | "md";
}) {
  const { t } = useTranslation();
  if (ownerProTier !== "premier") return null;

  return (
    <span
      className={cn(
        "inline-flex max-w-full shrink-0 items-center gap-1 rounded-full bg-amber-400/90 font-bold uppercase tracking-wide text-brand shadow-sm",
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-xs",
      )}
    >
      <Crown className={cn("shrink-0", size === "sm" ? "h-2.5 w-2.5" : "h-3.5 w-3.5")} aria-hidden="true" />
      <span className="min-w-0 break-words">{t("carCard.pro_owner")}</span>
    </span>
  );
}